import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { api, auth } from "./api";
import { ProgressProvider } from "./progress";
import { ToastProvider, Loading } from "./admin/common";
import Login from "./admin/Login";
import Layout from "./admin/Layout";
import Dashboard from "./admin/Dashboard";
import Bets from "./admin/Bets";
import System from "./admin/System";
import Chat from "./admin/Chat";
import Performance from "./admin/Performance";
import Settings from "./admin/Settings";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<LoginGate />} />
        <Route path="/*" element={<AdminApp />} />
      </Routes>
    </BrowserRouter>
  );
}

function LoginGate() {
  if (auth.token) return <Navigate to="/" replace />;
  return <Login />;
}

function AdminApp() {
  const [user, setUser] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    let alive = true;
    (async () => {
      if (auth.token) {
        try { const { user } = await api("/auth/me"); if (alive) setUser(user); } catch { /* session expirée */ }
      }
      if (alive) setReady(true);
    })();
    const onLogout = () => setUser(null);
    window.addEventListener("predicty-logout", onLogout);
    return () => { alive = false; window.removeEventListener("predicty-logout", onLogout); };
  }, []);

  if (!ready) return <div className="app-center" style={{ minHeight: "100vh" }}><Loading /></div>;
  if (!user) return <Navigate to="/login" replace />;

  return (
    <ToastProvider>
      <ProgressProvider>
        <Layout user={user}>
          <Routes>
            <Route index element={<Dashboard />} />
            <Route path="paris" element={<Bets />} />
            <Route path="systeme" element={<System />} />
            <Route path="manager" element={<Chat />} />
            <Route path="performance" element={<Performance />} />
            <Route path="reglages" element={<Settings />} />
            {/* anciennes adresses (avant la refonte du 20/10) */}
            <Route path="opportunites" element={<Navigate to="/paris" replace />} />
            <Route path="agents" element={<Navigate to="/systeme" replace />} />
            <Route path="apprentissage" element={<Navigate to="/performance" replace />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </Layout>
      </ProgressProvider>
    </ToastProvider>
  );
}
